export const escapeForRegExp = (str) => {
	if (!str || typeof str !== 'string') {
		return '';
	} else if (typeof RegExp.escape === 'function') {
		return RegExp.escape(str);
	} else {
		return str.replace(/[.*+?^$|{}()[\]\\]/g, '\\$&');
	}
};
